import React from 'react';
import { useSelector } from 'react-redux';
import colors from '../../utils/colors';

const label = {
  completed: {
    en: 'Completed',
    id: 'Selesai'
  },
  ongoing: {
    en: 'Ongoing',
    id: 'Berjalan'
  },
  upcoming: {
    en: 'Upcoming',
    id: 'Mendatang'
  }
}

const ActivityStatus = ({value}) => {
  const { /* activityStatusById, */ language = {} } = useSelector(state => state.system)

  return <>{
    value[language.name] === 'upcoming' ? (
      <span style={{color: colors.orange}}>{label.upcoming[language.name]}</span>
    ) : value[language.name] === 'ongoing' ? (
      <span style={{color: colors.green}}>{label.ongoing[language.name]}</span>
    ) : value[language.name] === 'completed' ? (
      <span className="text-gray-999">{label.completed[language.name]}</span>
    ) : (
      <span className="text-gray-999">{String(value)}</span>
    )
  }</>
}

export { ActivityStatus }
